import { company, Flow, flowMeta, flowOrder, navLinks } from '../content/site';
import { Wordmark } from './Wordmark';
import './Footer.css';

type Props = {
  onChoose: (flow: Flow) => void;
};

export function Footer({ onChoose }: Props) {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <Wordmark tone="light" />
          <p className="footer__tagline">{company.tagline}</p>
          <p className="footer__blurb">
            Acquiring wills, probate and estate planning practices and will banks
            from solicitors and will writers across England and Wales.
          </p>
        </div>

        <nav className="footer__col" aria-label="Sections">
          <h2 className="footer__col-title">Sections</h2>
          <ul className="footer__list">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a className="footer__link" href={link.href}>
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="footer__col">
          <h2 className="footer__col-title">Get started</h2>
          <ul className="footer__list">
            {flowOrder.map((flow) => (
              <li key={flow}>
                <a
                  className="footer__link"
                  href="#enquire"
                  onClick={() => onChoose(flow)}
                >
                  {flowMeta[flow].cta}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer__col">
          <h2 className="footer__col-title">Confidential contact</h2>
          <ul className="footer__list">
            <li>
              <a className="footer__link" href={`mailto:${company.email}`}>
                {company.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="container footer__legal">
        <p>
          © {year} {company.legalName}. Registered in England and Wales, company
          number {company.companyNumber}. {company.address}.
        </p>
        <p>
          Acquisitions complete into an SRA-authorised body, SRA number{' '}
          {company.sraNumber}. Nothing on this site is legal, tax or financial
          advice.
        </p>
      </div>
    </footer>
  );
}
